import {useCallback} from "react";
import {call} from "redux-saga/effects";

import {useSagaCallback} from "../utils/sagas";
import {apiPost, useGetRequestData} from './client';

export const useSaveFolders = (feedbackCh, type, id) =>
    useGetRequestData(feedbackCh, `/api/v2/folder/get_folders.json?community=Win${type ? `&type=${type}&id=${id}` : ''}`)?.folders;

export const useSaveToFolder = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, isPost, folder) {
        yield call(apiPost, `/api/v2/action/save`, {
            id,
            type: isPost,
            category: folder,
        });
    }, []));
};

export const useUnsaveToFolder = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, isPost, folder) {
        yield call(apiPost, `/api/v2/action/unsave`, {
            id,
            type: isPost,
            category: folder,
        });
    }, []));
};
